import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// img
import clockIcon from "../../../assets/svg/ic-clock.svg";

// Jds
import {
  ActionButton,
  Button,
  Container,
  Icon,
  InputDate,
  InputField,
  InputToggle,
  Text,
} from "@jds/core";

// Local
import CustomeTimePicker from "./customeTimePicker/CustomeTimePicker";
import useInput from "../../../hooks/use-input";
import { validateTextInput } from "../../../util/validation";
import useApiHttp from "../../../hooks/use-http";
import dayjs from "dayjs";
import {
  convertDateFormat,
  convertRailwayTimeToStandardTime,
  convertToRailwayTime,
  timeFormatMUI,
  todayDate,
} from "../../../util/helper";
import FormErrorLabel from "../FormErrorLabel/FormErrorLabel";
import { Box, FormControlLabel, Switch } from "@mui/material";
import JdsModal from "../JdsModal";
import EmptyState from "../../NoData/EmptyState";
import { useDispatch, useSelector } from "react-redux";
import { setPremiumAlertModalClose } from "../../../store/state-slices/plans";

export default function FolderForm(props) {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { premiumPlanId } = useSelector((state) => state.plans);
  const { role } = useSelector((state) => state);
  const data = props?.editData;
  const isWatermarkAvailable = props?.isWatermarkAvailable;
  const { sendRequest, isLoading } = useApiHttp();
  const {
    value: enteredName,
    isValid: enteredNameIsValid,
    hasError: enteredNameHasError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
    reset: resetNameInput,
  } = useInput(validateTextInput, {
    type: "text",
    value: data?.name || "",
  });

  const {
    value: date,
    isValid: dateIsValid,
    hasError: dateHasError,
    valueChangeHandler: dateChangeHandler,
    inputBlurHandler: dateBlurHandler,
    reset: resetdateInput,
  } = useInput(
    (data) => {
      const date = new Date(data);
      if (Object.prototype.toString.call(date) === "[object Date]") {
        if (isNaN(date.getTime())) {
          return false;
        } else {
          return true;
        }
      }
    },
    { type: "text", value: props?.editData && data?.date }
  );
  const [isPremium, setIsPremium] = useState(data?.isPremium);
  const [isWatermarkAlertModalClose, setIsWatermarkAlertModalClose] =
    useState(true);

  const {
    value: time,
    isValid: timeIsValid,
    hasError: timeHasError,
    valueChangeHandler: timeChangeHandler,
    inputBlurHandler: timeBlurHandler,
    reset: resetTimeInput,
  } = useInput(
    (data) => {
      if (data !== null) {
        return true;
      } else {
        return false;
      }
    },
    {
      type: "text",
      value: data?.time ? convertRailwayTimeToStandardTime(data?.time) : null,
    }
  );
  let isFormValid = false;
  // if (enteredNameIsValid && dateIsValid && timeIsValid) {
  //   isFormValid = true;
  // }
  if (enteredNameIsValid && dateIsValid) {
    isFormValid = true;
  }

  const formSubmitHandler = () => {
    nameBlurHandler(enteredName);
    dateBlurHandler(date);
    timeBlurHandler(time);

    if (!isFormValid) {
      return;
    }

    // let formatTime = dayjs(time).format("HH:mm:ss");
    props?.onSubmit?.({
      name: enteredName,
      eventId,
      date:
        convertDateFormat(date) == "NaN-aN-aN" ? date : convertDateFormat(date),
      // time:
      //   formatTime == "Invalid Date" ? convertToRailwayTime(time) : formatTime,
      time: "00:00",
      isPremium: isPremium,
    });
  };
  useEffect(() => {
    if (props.apiSuccess) {
      props.closeModal();
    }
  }, [props.apiSuccess]);
  return (
    <>
      <form
        action=""
        className="column-form fullwidth"
        onSubmit={formSubmitHandler}
      >
        <InputField
          label="Name"
          value={enteredName}
          onChange={nameChangeHandler}
          // onBlur={nameBlurHandler}
          state={enteredNameHasError ? "error" : "none"}
          stateConfig={{ errorText: "Please enter a valid folder name" }}
        />
        <InputDate
          value={props?.editData ? date : undefined}
          label="Date"
          name={props?.editData ? "edit-date" : "date"}
          onChange={(value) => {
            dateChangeHandler({ target: { value } });
          }}
          error={dateHasError}
          errorText="Please enter valid date"
        // min={props?.editData ? "" : todayDate()}
        />
        {/* <InputToggle
        type="toggle"
        label="Premium"
        name="premium"
        size="medium"
        checked={false}
        onChange={(e) => {
          props?.isWatermarkAvailable && setIsPremium(e.target.checked);
        }}
      ></InputToggle> */}
        {/* {role?.isAdmin && <FormControlLabel
          checked={!isPremium && !isWatermarkAvailable ? false : isPremium}
          control={<Switch />}
          label={<Text text="Premium" color="primary_grey_80" />}
          labelPlacement="start"
          onChange={(e) => {
            const isChecked = e.target.checked;
            if (isWatermarkAvailable) {
              setIsPremium(isChecked);
            } else {
              if (!isPremium) {
                setIsWatermarkAlertModalClose(false);
              } else {
                setIsPremium(isChecked);
              }
            }
            // else if (!isPremium && !isWatermarkAvailable) {
            //   setIsWatermarkAlertModalClose(false);
            //   setIsPremium(false);
            // } 
          }}
          sx={{ ml: 0, justifyContent: "flex-end" }}
        />} */}
        {/* <CustomeTimePicker
        label="Event Time"
        slotProps={{
          textField: {
            variant: "standard",
          },
          inputAdornment: {
            sx: {
              marginRight: "15px",
              marginBottom: "10px",
            },
          },
        }}
        value={timeFormatMUI(time) || null}
        // slots={{ openPickerIcon: () => <img src={clockIcon} /> }}
        slots={{
          openPickerIcon: () => (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM11 11C11 11.2652 10.8946 11.5196 10.7071 11.7071C10.5196 11.8946 10.2652 12 10 12H7C6.73479 12 6.48043 11.8946 6.2929 11.7071C6.10536 11.5196 6 11.2652 6 11C6 10.7348 6.10536 10.4804 6.2929 10.2929C6.48043 10.1054 6.73479 10 7 10H9V7C9 6.73478 9.10536 6.48043 9.2929 6.29289C9.48043 6.10536 9.73479 6 10 6C10.2652 6 10.5196 6.10536 10.7071 6.29289C10.8946 6.48043 11 6.73478 11 7V11Z"
                fill="var(--color-primary-60)"
              />
            </svg>
          ),
        }}
        onChange={(value) => {
          let formatTime = dayjs(value).format("HH:mm:ss");
          timeChangeHandler({
            target: { value: convertRailwayTimeToStandardTime(formatTime) },
          });
        }}
      />
      {timeHasError && <FormErrorLabel errorMsg="Enter valid time" />} */}
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ marginTop: "16px" }}
        >
          <ActionButton
            size="large"
            label={props?.editData ? "Update" : "Add"}
            onClick={() => {
              formSubmitHandler();
            }}
            state={isLoading && "loading"}
          />
        </Container>
      </form>
      <JdsModal
        size="m"
        kind="informational"
        close={isWatermarkAlertModalClose}
        onClose={() => {
          setIsWatermarkAlertModalClose(true);
        }}
      >
        <Box>
          <EmptyState
            title="Watermark not found for this Event!"
            subtitle="Please create watermark to enable premium feature."
            action={false}
          />
          <Container
            fullWidth
            horizontalAlign="center"
            style={{ marginTop: "16px" }}
          >
            <Button
              label="Create Watermark"
              icon={"IcArrowNext"}
              onClick={() =>
                navigate(`/home/events/event-detail/${eventId}`, {
                  state: { isWatermarkModalOpen: true },
                })
              }
            />
          </Container>
        </Box>
      </JdsModal>
    </>
  );
}
